module.exports = __webpack_public_path__ + "static/media/envelope.d0df1ebe.svg";